import React, { createContext, useEffect, useState } from 'react';
import { fetchCreatorQualityData } from './api';
import { OrganizerContextState, OrganizerContextValue } from './types';

export const OrganizerContext = createContext<OrganizerContextValue | null>(
    null,
);

interface OrganizerProviderProps {
    children: React.ReactNode;
    initialState: OrganizerContextState;
}

export const OrganizerProvider: React.FC<OrganizerProviderProps> = ({
    children,
    initialState,
}) => {
    const [organizerInfo, setOrganizerInfo] =
        useState<OrganizerContextState>(initialState);

    useEffect(() => {
        if (!organizerInfo.basicInfo.id || !!initialState.qualityInfo) {
            return;
        }

        const abortController = new AbortController();
        let isMounted = true;

        fetchCreatorQualityData(
            organizerInfo.basicInfo.id,
            abortController.signal,
        )
            .then((result) => {
                if (isMounted) {
                    setOrganizerInfo((prevState) => ({
                        ...prevState,
                        qualityInfo: {
                            creatorSignalData:
                                result.creatorSignalData || undefined,
                            creatorBadgeData:
                                result.creatorBadgeData || undefined,
                            isLoadingSignal: false,
                        },
                    }));
                }
            })
            .catch((e) => {
                if (e.name === 'AbortError' || !isMounted) {
                    return;
                }
                console.error('Error fetching creator quality data:', e);
                setOrganizerInfo((prevState) => ({
                    ...prevState,
                    qualityInfo: {
                        isLoadingSignal: false,
                    },
                }));
            });

        return () => {
            isMounted = false;
            abortController.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizerInfo.basicInfo.id]);

    return (
        <OrganizerContext.Provider value={organizerInfo}>
            {children}
        </OrganizerContext.Provider>
    );
};
